import { render } from "./manualhandling-list.vue?vue&type=template&id=ab509166"
import script from "./manualhandling-list.vue?vue&type=script&lang=js"
export * from "./manualhandling-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__